import React from 'react'

const ReceiveableView = () => {
  return (
    <div>ReceiveableView</div>
  )
}

export default ReceiveableView